import { IWorkspaceColumnOverride } from '../@types/workspaceTypes';
import { useSelector } from 'react-redux';
import { CostViewPermission } from '../graphql/schema/p4types';
import { useMemo } from 'react';

export const useAbstractPurchaseLineColumnOverrides = (
  baseColumnOverrides: IWorkspaceColumnOverride
): IWorkspaceColumnOverride => {
  const costViewPermission =
    useSelector((store: any) => store.app?.fullUserDetails?.companyUser?.costViewPermission) ?? CostViewPermission.None;

  return useMemo(() => {
    if (costViewPermission != CostViewPermission.All) {
      return {
        ...baseColumnOverrides,
        grossSellingPrice: {
          disabled: true,
        },
        nettSellingPrice: {
          disabled: true,
        },
        singleUnitGrossSellingPrice: {
          disabled: true,
        },
        totalAdditionalCost: {
          disabled: true,
        },
        unitAdditionalCost: {
          disabled: true,
        },
        nettLineValue: {
          disabled: true,
        },
        discount: {
          disabled: true,
        },
        discountPercentage: {
          disabled: true,
        },
      };
    }
    return baseColumnOverrides;
  }, [baseColumnOverrides, costViewPermission]);
};
